module.exports = __webpack_public_path__ + "img/two_txt.9302d4bd.png";